
(function containerTypeDefinition() {
    'use strict';
    angular.module('Entities')
        .service('containerTypeService', [
            'restUrlBuilder', '$filter', 'authExtend', '$q', 'config', function containerTypeService(restUrlBuilder, $filter, auth, $q, config) {

                var functionsDTypes = undefined;
                var _leg = undefined;

                auth.onIdentityChanged(function () {
                    functionsDTypes = undefined;
                    _leg = undefined;
                });

                this.getFunctionsDocTypes = function getFDT() {       
                    if (functionsDTypes) {
                        var defered = $q.defer();
                        var promise = defered.promise;
                        defered.resolve(functionsDTypes);
                        return promise;
                    }

                    var functions = auth.getRoles();


                    return restUrlBuilder.one('functions', config.appId())
                        .all('containerTypes')
                        .get();
                }



                this.getById = function getById(id) {
                    return this.getContainerById(id);
                };

                this.getBySystemName = function getBySN(systemName) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    if (_leg && systemName === '_leg') {                     
                        defered.resolve(_leg);
                        return promise;
                    }
                    
                    this.getContainerBySystemName(systemName).then(function (result) {
                        if (systemName === '_leg') {
                            _leg = result;
                        }

                        defered.resolve(result);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                };
                
                this.getContainerBySystemName = function getBySN(systemName) {
                    return restUrlBuilder.one('containerTypes/SystemName', systemName)
                        .get();
                };

                this.getContainerById = function getById(id, detailLevel) {
                    var params = { lod: detailLevel };

                    return restUrlBuilder.one('containerTypes', id)
                        .get({ params: params });
                };

                this.get = function get(name, organizationalUnitId) {

                    var params = { Name: name, OrganizationalUnitId: organizationalUnitId};

                    return restUrlBuilder.all('containerTypes')
                        .get({ params: params });
                };

                this.getFunctionsTypes = function (functions) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.getFunctionsDocTypes().then(function (apiResult) {
                        functionsDTypes = apiResult;

                        var types = [];
                        functions.forEach(function (f) {
                            var results = $filter('filter')(functionsDTypes, { function: f }, true);
                            if (results.length > 0) {
                                results[0].docTypes.forEach(function (dt) {
                                    var dtr = $filter('filter')(types, { id: dt.id }, true);
                                    if (dtr.length === 0) {
                                        types.push(dt);
                                    }
                                });
                            }
                        });

                        defered.resolve(types);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }

                this.isContainertypeInRole = function (f, ctId) {
                    var defered = $q.defer();
                    var promise = defered.promise;

                    this.getFunctionsTypes(f).then(function (types) {
                        defered.resolve($filter('filter')(types, { id: ctId }, true).length > 0);
                    }, function (error) {
                        defered.reject(error);
                    });

                    return promise;
                }
            }
        ]);

})();